import {
  ModuleIOValueTypeEnum,
  ModuleInputKeyEnum,
  ModuleOutputKeyEnum,
  ModuleTemplateTypeEnum,
} from '../../constants';
import {
  FlowNodeInputTypeEnum,
  FlowNodeOutputTypeEnum,
  FlowNodeTypeEnum,
} from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';

export const UserChatInputModule: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.userChatInput,
  templateType: ModuleTemplateTypeEnum.getContent,
  flowType: FlowNodeTypeEnum.userChatInput,
  avatar: '/imgs/module/userChatInput.svg',
  name: '用户输入',
  description: '当用户发送一个内容后，流程将会从这个模块开始执行。',
  inputs: [
    {
      key: ModuleInputKeyEnum.userChatInput,
      type: FlowNodeInputTypeEnum.systemInput,
      valueType: ModuleIOValueTypeEnum.string,
      label: '用户问题',
      showTargetInApp: false,
      showTargetInPlugin: false,
      value: '{userChatInput}',
    },
  ],
  outputs: [
    {
      key: ModuleOutputKeyEnum.userChatInput,
      label: '用户问题',
      type: FlowNodeOutputTypeEnum.source,
      valueType: ModuleIOValueTypeEnum.string,
      targets: [],
    },
  ],
};
